/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import getData from './getData.tsx';

const RESOURCE_TYPE_CSM_BASE_URL = 'CSM_SUPPORT_SITE_BASE_URL';

export const csmBaseUrlResource: RouteResource<string> = createResource<string>({
	type: RESOURCE_TYPE_CSM_BASE_URL,
	getKey: () => 'csm-support-site-base-url',
	getData: async () => getData(),
	maxAge: 0,
});
